// CreateCase Page constants
export const CreateCaseConstants = {
  CREATE_CASE_HEADER: 'create_case_page_header',
  CREATE_CASE_FAILURE_HEADER: 'error_message_case_registration_failed_header',
  CREATE_CASE_FAILURE_DESCRIPTION:
    'error_message_case_registration_failed_message',
  CREATE_CASE_CLIENT_SIDE_ERRORS:
    'error_message_client_side_validation_there_are_errors_on_the_form_fix_and_resubmit',
  CASE_LISTING_TEXT: 'case_list_table_header_case_listing',
  NOT_AUTHORIZED: 'error_message_not_authorized',
  SUBMIT: 'submit_button_text_submit',
  ADD_ATTACHMENTS: 'uploader_component_add_attachment_section',
};

//Correspondence Text Editor constants
export const CorrespondenceTextEditorConstants = {
  ADD_COMMENT: 'correspondence_page_button_add_comment',
  SHOW_TO_EXTERNAL_USERS:
    'correspondence_page_checkbox_show_to_external_users_label',
  MAX_COMMENT_LENGTH: 5000,
  POST_CORRESPONDENCE:
    'correspondence_page_textarea_label_post_to_correspondence',

  //Error Messages
  ERROR_LOADING_COMMENTS: 'error_message_failed_to_load_comments',
  ERROR_POST_CORRESPONDENCE: 'error_message_unable_to_post_correspondence',

  //Post Badge constants
  BADGE_INTERNAL_POST: 'comment_badge_internal_post',
  BADGE_EXTERNAL_POST: 'comment_badge_external_post',
  BADGE_ACK_TO_EXTERNAL: 'comment_badge_ack_to_external',
  BADGE_ACK_TO_INTERNAL: 'comment_badge_ack_to_internal',
};

export const ViewCaseConstants = {
  //Error Messages
  ERROR_LOADING_CASE_ID: `error_message_failure_to_load_case_id`,
};

export const AuthConstants = {
  NO_ACCOUNT_MAPPING: `error_message_no_account_associated_with_login`,
  NO_ACCOUNT_MAPPING_IN_EXTERNAL_PORTAL:
    'error_message_no_account_associated_with_external_login',
};

export const CaseDetailsConstants = {
  TAB_CASE_DETAILS: 'case_details_page_title_case_overview',
  TAB_COMMUNICATION: 'case_details_page_title_communication',
};

export const CaseSummaryConstants = {
  EDIT_CASE_OVERVIEW: 'case_summary_panel_edit_case_overview_section',
  CASE_OVERVIEW_HEADING: 'case_summary_panel_case_overview_section',
  SAVE_BUTTON_TEXT: 'save_button_text_save',
  EDIT_BUTTON_TEXT: 'save_button_text_edit',
  ERROR_MESSAGE_UNABLE_TO_UPDATE_DATA: 'error_message_unable_to_update_case',
};

export const CaseListConstants = {
  CASE_TEXT: 'case_list_table_column_header_case_id',
  PARAGON_CASE_IDS: 'case_list_table_column_header_paragon_case_ids',
  CREATED_DATE_TEXT: 'case_list_table_column_header_created_date',
  LAST_UPDATED_TEXT: 'case_list_table_column_header_last_correspondence_date',
  TITLE_TEXT: 'case_list_table_column_header_title',
  CREATED_BY_TEXT: 'case_list_table_column_header_created_by',
  LAST_UPDATED_BY: 'case_list_table_column_header_last_updated_by',
  NO_EXISTING_CASE_PRESENT_MESSAGE: 'error_message_no_existing_cases_present',
  UNABLE_TO_LOAD_CASES_MESSAGE:
    'error_message_unable_to_load_cases_at_this_moment',
  CASE_STATUS: 'case_list_table_column_header_status',
  ASSIGNEE: 'case_list_table_column_header_assignee',
  CASE_LOCALE: 'case_list_table_column_header_case_locale',
};

export const UploaderConstants = {
  DEFAULT_HINT: 'uploader_component_hint_message_you_can_drag_files_to_upload',
  ERROR_EMPTY_S3_URL: 'S3 URL received is null or empty',
  ERROR_UNABLE_TO_UPLOAD_FILE_TO_DMS_S3:
    'Error while uploading file to DMS S3.',
  ERROR_UNABLE_TO_TRIGGER_CREATE_DOCUMENT:
    'Error while triggering createDocument in DMS.',
  ERROR_UPLOAD_TO_DMS: 'Error while uploading file to DMS.',
  UPLOADER_CONSTRAINT_MESSAGE:
    'uploader_component_constraint_message_images_documents_accepted_within_limit',
  ERROR_GENERIC_MESSAGE_FOR_UI:
    'uploading_component_error_message_error_uploading_file_remove_and_retry',
  ALLOWED_FILETYPES:
    'uploading_component_constraint_popup_message_allowed_filetypes',
  ERROR_MAX_ATTACHMENTS_EXCEEDED:
    'uploader_component_error_message_max_attachments_exceeded',
  ERROR_TOTAL_SIZE_EXCEEDED:
    'uploader_component_error_message_total_size_exceeded',
};
export const FileAttachmentsConstants = {
  ATTACHMENTS_HEADER: 'case_details_page_header_attachments',
  ERROR_EMPTY_S3_URL: 'S3 URL received is null or empty',
  DOWNLOAD_ERROR_DESCRIPTION:
    'uploading_component_error_message_error_downloading_attachment_please_retry',
};

export const MenuConstants = {
  SIGNOUT_MENU_NAME: 'breadcrumb_menu_signout',
  SIGNIN_MENU_NAME: 'breadcrumb_menu_sigin',
  LOGIN_MENU_NAME: 'breadcrumb_menu_login',
};

export const BreadCrumbConstants = {
  HOME: 'breadcrumb_menu_home',
  CREATE_CASE: 'breadcrumb_menu_create_case',
  VIEW_CASE: 'breadcrumb_menu_view_case',
};

export const CommonBundleConstants = {
  ACTION_BUTTON_LABEL_CLOSE: 'button_text_close',
};
export const SustainabilityLandingPageConstants = {
  TRUST_SECTION_HEADER:
    'human_rights_and_environmental_complaints_section_heading',
  TRUST_SECTION_DESCRIPTION_HEADER: 'hre_complaints_section_description_header',
  TRUST_SECTION_DESCRIPTION_INFORMATION:
    'hre_complaints_section_description_information',
  AFFECTED_CATEGORY_CHILD_LABOUR_YOUNG_WORKERS:
    'hre_complaints_affected_category_child_labour_young_workers',
  AFFECTED_CATEGORY_FORCED_LABOUR_MODERN_SLAVERY:
    'hre_complaints_affected_category_forced_labour_modern_slavery',
  AFFECTED_CATEGORY_OCCUPATION_HEALTH_SAFETY:
    'hre_complaints_affected_category_occupation_health_safety',
  AFFECTED_CATEGORY_WAGES_AND_BENEFITS:
    'hre_complaints_affected_category_wages_and_benefits',
  AFFECTED_CATEGORY_WORKING_HOURS:
    'hre_complaints_affected_category_working_hours',
  AFFECTED_CATEGORY_DISCRIMINATION_AND_HARRASMENT:
    'hre_complaints_affected_category_discrimination_and_harrasment',
  AFFECTED_CATEGORY_UNETHICAL_BEHAVOUR_AND_CORRUPTION:
    'hre_complaints_affected_category_unethical_behaviour_and_corruption',
  AFFECTED_CATEGORY_RIGHT_TO_PEACEFULY_ASSOCIATE_ASSAMBLE_WITH_OTHERS:
    'hre_complaints_affected_category_right_to_peacefully_associate_and_assamble_with_others',
  AFFECTED_CATEGORY_LAND_AND_NATURAL_RESOURCES:
    'hre_complaints_affected_category_land_and_natural_resources',
  AFFECTED_CATEGORY_HAZARDOUS_WASTE_MANAGEMENT_AND_DISPOSE:
    'hre_complaints_affected_category_hazardous_waste_management_and_disposal',
  TRUST_SECTION_DESCRIPTION_WHAT_NOT_TO_REPORT:
    'hre_complaints_section_description_what_not_to_report',
  TRUST_SECTION_DESCRIPTION_EMERFENCY_REPORTING:
    'hre_complaints_section_description_emergency_reporting',
  TRUST_SECTION_DESCRIPTION_FAQ: 'hre_complaints_section_description_faq',
  HOW_TO_REPORT_HEADING: 'how_to_report_heading',
  REPORTING_CARD_ANONYMOUSLY_HEADER:
    'report_anonymously_offering_section_header',
  REPORTING_CARD_ANONYMOUSLY_DESCRIPTION:
    'report_anonymously_offering_section_description',
  REPORTING_CARD_ANONYMOUSLY_ACTION_BUTTON_LABEL:
    'report_anonymously_offering_section_action',
  REPORTING_CARD_ANONYMOUS_LOGIN_HEADER:
    'login_and_report_offering_section_header',
  REPORTING_CARD_ANONYMOUS_LOGIN_DESCRIPTION:
    'login_and_report_offering_section_description',
  REPORTING_CARD_ANONYMOUS_LOGIN_ACTION_BUTTON_LABEL_SIGN_IN:
    'login_and_report_offering_section_action',

  REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_HEADER:
    'login_and_report_loggedin_view_section_header',
  REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_DESCRIPTION:
    'login_and_report_loggedin_view_section_description',
  REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_PRIMARY_ACTION_REPORT:
    'login_and_report_loggedin_view_section_primary_action',
  REPORTING_CARD_LOGGED_IN_VIEW_LOGIN_SECONDARY_ACTION_TRACK_ISSUES:
    'login_and_report_loggedin_view_section_secondary_action',

  REPORTING_CARD_LOGIN_ACTION_BUTTON_LABEL_CLOSE: 'button_text_close',
  CASE_TITLE_REPORT_A: 'case_title_text_report_a',
  CASE_TITLE_INCIDENT: 'case_title_text_incident',
  REPORT_A_CASE_HEADER: 'report_a_case_section_header',
  REPORT_A_CASE_DESCRIPTION: 'report_a_case_section_description',
  ANONYMOUS_CREATE_CASE_MODAL_TITLE: 'anonymous_case_creation_modal_title',
  CAPTCHA_MODAL_TITLE: 'captcha_modal_title',
  ANONYMOUS_CREATE_CASE_MODAL_SUCCESS_MESSAGE:
    'anonymous_case_creation_success_message',
  ANONYMOUS_CREATE_CASE_FAILURE_MESSAGE:
    'anonymous_case_creation_failure_message',
};

export const CsamPublicPageConstants = {
  TRUST_SECTION_HEADER: 'report_child_sexual_abuse_material_section_heading',
  TRUST_SECTION_MESSAGE:
    'report_child_sexual_abuse_material_section_description',
  TRUST_SECTION_MESSAGE_ADDITIONAL_INFORMATION:
    'report_child_sexual_abuse_material_section_additional_information',
  REPORT_A_CASE_FORM_HEADER: 'report_a_case_form_header',
  REPORT_A_CASE_FORM_DESCRIPTION: 'report_a_case_form_description',
  REPORT_A_CASE_DISCLAINER_FIELD_TEXT:
    'report_a_case_form_disclaimer_field_text',
  CAPTCHA_MODAL_TITLE: 'captcha_modal_title',
  REPORT_AN_ISSUE_SUCCESS_MODAL_HEADER: 'report_an_issue_success_modal_header',
  REPORT_AN_ISSUE_SUCCESS_MODAL_TEXT: 'report_an_issue_success_modal_text',
  REPORT_AN_ISSUE_SUCCESS_MODAL_MESSAGE:
    'report_an_issue_success_modal_message',
  REPORT_AN_ISSUE_FAILURE_MODAL_MESSAGE:
    'report_an_issue_failure_modal_message',
  MAX_CHARACTERS_FIELD_MESSAGE: 'max_characters_message',
  MANDATORY_FIELD_ERROR_MESSAGE: 'mandatory_field_error_message',
};

export const DSAPOCPublicPageConstants = {
  TRUST_SECTION_HEADER: 'DSA Article 11 Point of Contact',
  TRUST_SECTION_MESSAGE:
    'Pursuant to Article 11 of Regulation (EU) 2022/2065 (the DSA), we created a single point of contact email address to enable direct communication with Member States’ authorities, the European Commission, and the European Board for Digital Services for the application of the DSA. To request this email address, please fill out the form below, and a member of our DSA Compliance Function will reach out to you. When contacting us via the DSA single point of contact email address, we kindly request that English is preferentially used. We can also accept communication in German and French.',
  TRUST_SECTION_MESSAGE_ADDITIONAL_INFORMATION:
    'Please note, if you submit a report via this tool, we will reach out to you within 2-3 business days.',
  REPORT_A_CASE_FORM_HEADER: 'Request Contact',
  REPORT_A_CASE_FORM_DESCRIPTION: '',
  CAPTCHA_MODAL_TITLE: 'Solve the puzzle',
  REPORT_AN_ISSUE_SUCCESS_MODAL_HEADER: 'Report an Issue',
  REPORT_AN_ISSUE_SUCCESS_MODAL_TEXT: 'Thank you!',
  REPORT_AN_ISSUE_SUCCESS_MODAL_MESSAGE:
    'Thank you for submitting your request! We will reach out to you accordingly.',
  REPORT_AN_ISSUE_FAILURE_MODAL_MESSAGE:
    'An unexpected error occurred. Please try again.',
  REPORT_AN_ISSUE_ACTION_BUTTON_LABEL_CLOSE: 'Close',
  MAX_CHARACTERS_FIELD_MESSAGE:
    'Maximum {max_characters} characters ({0,number,integer} remaining)',
  MANDATORY_FIELD_ERROR_MESSAGE:
    '"This is a mandatory field. Please ensure that it is completed before submitting the form.',
};

export const PaymentServicesComplaintPageConstants = {
  TRUST_SECTION_HEADER: 'report_payment_services_complaint_section_header',
  TRUST_SECTION_MESSAGE:
    'report_payment_services_complaint_section_description',
  TRUST_SECTION_MESSAGE_ADDITIONAL_INFORMATION:
    'report_payment_services_complaint_section_additional_information',
  REPORTING_OTHER_SELLER_CENTRAL_ISSUES:
    'report_payment_service_complaint_section_reporting_seller_issues',
  REPORTING_FBA_ISSUES:
    'report_payment_service_complaint_section_report_fba_issues',
  REPORTING_BUYER_ISSUES:
    'report_payment_service_complaint_section_report_buyer_issues',
  REPORT_A_CASE_FORM_HEADER: 'report_a_case_form_header',
  REPORT_A_CASE_DISCLAINER_FIELD_TEXT:
    'report_a_case_form_disclaimer_field_text',
  CAPTCHA_MODAL_TITLE: 'captcha_modal_title',
  REPORT_AN_ISSUE_SUCCESS_MODAL_HEADER: 'report_an_issue_success_modal_header',
  REPORT_AN_ISSUE_SUCCESS_MODAL_MESSAGE:
    'report_an_issue_success_modal_message',
  REPORT_AN_ISSUE_FAILURE_MODAL_MESSAGE:
    'report_an_issue_failure_modal_message',
  MANDATORY_FIELD_ERROR_MESSAGE: 'mandatory_field_error_message',
};

export const ReadMoreConstants = {
  READ_MORE: 'button_text_read_more',
  READ_LESS: 'button_text_read_less',
};
